export enum CloseLoopManualConfirmType {
    
     ToWaitlist = 1,
     NonDirected = 8,
     Direct = 2,
     InternalKpd = 3,
     StandardVoucher = 5,
     FamilyVoucher = 6,
     NonDirectedNkr = 9,
     RemoteDirectNkr = 10,
     KidneyForLifeInternal = 11,
     NkrKpd = 4,
     AlternateKpdProgram = 7
}